import { render, staticRenderFns } from "./AudienceTable.vue?vue&type=template&id=3367f3c5&scoped=true&"
import script from "./AudienceTable.vue?vue&type=script&lang=js&"
export * from "./AudienceTable.vue?vue&type=script&lang=js&"
import style0 from "./AudienceTable.vue?vue&type=style&index=0&id=3367f3c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3367f3c5",
  null
  
)

export default component.exports